<template>
  <div class="home" :class="!$isCN() && 'home-en'">
    <div :id="!isMobile && 'fullpage'" ref="fullpage">
      <div class="section fullpage">
        <Header class="header" ref="header" />
      </div>
      <div class="section page2 fullpage">
        <div id="page2-partical"></div>
        <div class="fp-wrapper">
          <div class="content" :class="$isCN() ? '' : 'content-en'">
            <IntroduceCard
              class="item item-l"
              :sub="$t('introduces')[0].sub"
              :detail="$t('introduces')[0].detail"
              :title="(isMobile && $t('introduces')[0].titleM) || $t('introduces')[0].title"
              :lines="$t('introduces')[0][isMobile ? 'linesM' : 'lines']"
            >
            </IntroduceCard>
            <IntroduceCard
              class="item item-m"
              :title="(isMobile && $t('introduces')[1].titleM) || $t('introduces')[1].title"
              :sub="$t('introduces')[1].sub"
              :subTail="$t('introduces')[1].subTail"
              :detail="$t('introduces')[1].detail"
              :lines="$t('introduces')[1][isMobile ? 'linesM' : 'lines']"
            >
            </IntroduceCard>
            <IntroduceCard
              class="item item-r"
              :sub="$t('introduces')[2].sub"
              :detail="$t('introduces')[2].detail"
              :title="(isMobile && $t('introduces')[2].titleM) || $t('introduces')[2].title"
              :lines="$t('introduces')[2][isMobile ? 'linesM' : 'lines']"
            >
            </IntroduceCard>
            <IntroduceCard
              class="item item-l"
              :sub="(isMobile && $t('introduces')[3].subM) || $t('introduces')[3].sub"
              :detail="$t('introduces')[3].detail"
              :title="(isMobile && $t('introduces')[3].titleM) || $t('introduces')[3].title"
              :subClass="$t('introduces')[3].subClass"
              :lines="$t('introduces')[3][isMobile ? 'linesM' : 'lines']"
            >
            </IntroduceCard>
            <IntroduceCard
              class="item item-m"
              :detail="$t('introduces')[4].detail"
              :title="(isMobile && $t('introduces')[4].titleM) || $t('introduces')[4].title"
              :subTail="$t('introduces')[4].subTail"
              :sub="$t('introduces')[4].sub"
              :lines="$t('introduces')[4][isMobile ? 'linesM' : 'lines']"
            >
            </IntroduceCard>
            <IntroduceCard
              class="item item-r"
              :detail="$t('introduces')[5].detail"
              :title="(isMobile && $t('introduces')[5].titleM) || $t('introduces')[5].title"
              :sub="$t('introduces')[5].sub"
              :lines="$t('introduces')[5][isMobile ? 'linesM' : 'lines']"
            >
            </IntroduceCard>
            <div class="data-from" v-if="$isCN()">公司数据统计截止时间：2023.12.31<br />行业数据来源于：灼识咨询（2023）</div>
            <div class="data-from" v-else>
              Enterprise statistics as of December 31, 2023<br />Sources : China Insights Consultancy (2023)
            </div>
          </div>
        </div>
      </div>
      <div class="section fullpage">
        <div class="page3">
          <!-- <SolutionsVideo v-if="canPlayVideo()" />
          <Solutions v-else /> -->
          <SolutionSwitch />
        </div>
      </div>
      <div class="section">
        <no-ssr>
          <div class="page4">
            <div class="radar">
              <div class="radar-wave"></div>
              <div class="radar-wave"></div>
              <!-- <div class="radar-wave"></div> -->
            </div>
            <www-picture :noCompress="true" w="600" h="600" :img="$t('feilun')" class="page4-img" id="page4-img" ref="page4ImgEl" />
            <div v-if="$isCN()" class="page4-describe">
              <div class="page4-describe-title">大搜车飞轮效应</div>
              <div class="page4-describe-en">DaSouChe Flywheel</div>
            </div>
            <span class="page4-describe-en-version" v-if="!$isCN() && isMobile">DaSouChe Flywheel</span>
            <span class="page4-describe-en-version" v-if="!$isCN() && !isMobile">DaSouChe Flywheel</span>
          </div>
        </no-ssr>
        <MyFooter></MyFooter>
      </div>
    </div>
  </div>
</template>

<script>
import "fullpage.js/dist/fullpage.min.css";
import MyFooter from "../../components/MyFooter";
import SectionTitle from "../../components/SectionTitle.vue";
import Header from "../../components/home-header/index.vue";
import ParticalData from "../../data/partical-data";
import IntroduceCard from "../../components/home-introduce-card";
import SolutionSwitch from "../../components/home-solutions/switch.vue";

export default {
  computed: {
    scale() {
      return ((this.screenY / 1050) * 1.2).toFixed(1);
    },
    isIE() {
      return this.$store.state.isIE;
    },
    isMobile() {
      return this.$store.state.isMobileSite;
    },
  },
  watch: {
    isMobile() {
      this.loadFullPage();
    },
  },
  components: {
    SectionTitle,
    Header,
    MyFooter,
    IntroduceCard,
    SolutionSwitch,
  },
  methods: {
    onResize() {
      this.screenY = window.innerHeight;
    },
    destoryEffect() {
      if (this.destoryPjsFn) {
        this.destoryPjsFn();
      }
    },
    async loadEffects() {
      // if (this.particalLoaded) {
      //   return;
      // }
      // this.particalLoaded = true;
      import("../../utils/particles").then(() => {
        this.destoryPjsFn = window.particlesJS("page2-partical", ParticalData);
      });
    },
    onScroll() {
      if (!this.$refs.page4ImgEl && this.imgActived) {
        return;
      }
      const el = this.$refs.page4ImgEl.$el || this.$refs.page4ImgEl;
      const rect = el.getBoundingClientRect();
      if (rect.bottom < window.innerHeight + 50) {
        this.imgActived = true;
        document.querySelector("#page4-img").classList.add("page4-img-active");
        return;
      }
    },
    loadFullPageMob() {
      // this.$store.commit("nav/setNav", { transparent: true, whiteStyle: false });
      this.loadEffects();
      document.addEventListener("scroll", this.onScroll);
    },
    async loadFullPage() {
      if (this.myFullpage) {
        this.myFullpage.destroy("all");
      }
      if (this.isMobile) {
        this.loadFullPageMob();
        return;
      }
      document.removeEventListener("scroll", this.onScroll);
      try {
        const [module] = await Promise.all([import("fullpage.js"), import("fullpage.js/vendors/scrolloverflow.js")]);
        const Fullpage = module.default || module;
        const _this = this;
        this.myFullpage = new Fullpage("#fullpage", {
          "gplv3-license": "OPEN-SOURCE-GPLV3-LICENSE",
          // animateAnchor: false,
          // autoScrolling: false,
          scrollOverflow: true,
          // anchors: ["page1", "page2", "page3", "page4"],
          onLeave(curr, next) {},
          afterLoad(origin, curr) {
            try {
              _this.myFullpage.setAllowScrolling(false);
              setTimeout(() => {
                _this.myFullpage.setAllowScrolling(true);
              }, 500);
              _this.$refs.header.onScroll(curr.index === 0);
              if (curr.index === 1) {
                _this.$store.commit("nav/setNav", { whiteStyle: true, transparent: true });
                _this.loadEffects();
              } else {
                if (curr.index !== 0) {
                  _this.$store.commit("nav/setNav", { whiteStyle: false, transparent: true });
                }
                _this.destoryEffect();
              }
              if (curr.index === 3) {
                document.querySelector("#page4-img").classList.add("page4-img-active");
              } else {
                document.querySelector("#page4-img").classList.remove("page4-img-active");
              }
            } catch (e) {
              console.log(e);
            }
          },
        });
      } catch (e) {
        console.log(e);
      }
    },
  },

  mounted() {
    this.onScroll = this.onScroll.bind(this);
    this.loadFullPage();
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.onScroll);
    // if (!this.isMobile) {
    this.$store.commit("nav/setNav", { transparent: false, whiteStyle: false });
    // }
    if (this.myFullpage) {
      this.myFullpage.destroy("all");
    }
  },
  i18n: {
    messages: {
      zh: {
        title: "大搜车 - 汽车流通商的坚定赋能者",
        feilun: "//img.souche.com/f2e/1a4bb8368a6623065c2b304234eac495.png",
        introduces: [
          {
            title: "中国市占率第一的<br/>二手车商运营系统",
            titleM: "中国市占率第一的<br/>二手车商运营系统",
            detail: "市场占有率",
            sub: "90%",
            lines: 2,
            linesM: 3,
          },
          {
            title: "中国领先的<br/>汽车厂商用户运营系统服务",
            titleM: "中国领先的<br/>汽车厂商用户<br/>运营系统服务",
            detail: "累计汽车厂商客户",
            sub: "36",
            subTail: "家",
            lines: 2,
            linesM: 3,
          },
          {
            title: "中国领先的<br/>新车二网运营系统及信息平台",
            titleM: "中国领先的<br/>新车二网运营系统<br/>及信息平台",
            detail: "市场占有率",
            sub: "90%",
            lines: 2,
            linesM: 3,
          },
          {
            title: "中国领先的<br/>二手车B2B拍卖平台",
            titleM: "中国领先的<br/>二手车B2B<br/>拍卖平台",
            sub: "行业领先",
            subM: "行业<br/>领先",
            subClass: "market-leader",
            lines: 2,
            linesM: 3,
          },
          {
            title: "中国领先的<br/>二手车检测认证服务",
            sub: "80",
            detail: "年检测量",
            subTail: "万",
            lines: 2,
            linesM: 2,
          },
          {
            title: "中国领先的<br/>单车交付平台",
            sub: "2600+",
            detail: "覆盖区县",
            lines: 2,
            linesM: 2,
          },
        ],
      },
      en: {
        title: "SOUCHE - Dedicated Enabler to Auto Merchants",
        feilun: "//img.souche.com/f2e/12f76b5611b9b8ca80f359c43aebae1a.png",
        introduces: [
          {
            title: "No. 1 Operating System for<br/>Used Car Dealers in China",
            titleM: "No. 1 Operating<br/>System for Used Car<br/>Dealers in China",
            sub: "90%",
            detail: "Market Share",
            lines: 3,
            linesM: 3,
          },
          {
            title: "Leading Customer<br/>Engagement System for<br/>OEMs in China",
            titleM: "Leading Customer<br/>Engagement System<br/>for OEMs in China",
            sub: "36",
            detail: "OEM Clients",
            lines: 3,
            linesM: 3,
          },
          {
            title: "Leading Operating System<br/>and Information Platform for<br/>New Car Broker in China",
            titleM: "Leading Operating<br/>System and Information<br/>Platform for New Car<br/>Broker in China",
            sub: "90%",
            detail: "Market Share",
            lines: 3,
            linesM: 4,
          },
          {
            title: "Leading B2B Auction<br/>Platform for Used Car<br/>Dealers in China",
            titleM: "Leading B2B Auction<br/>Platform for Used Car<br/>Dealers in China",
            sub: "Market<br/>Leader",
            subClass: "market-leader",
            lines: 3,
            linesM: 4,
          },
          {
            title: "Leading Used Car<br/>Inspection and Certification<br/>Services in China",
            titleM: "Leading Used Car<br/>Inspection and<br/>Certification Services<br/>in China",
            sub: "800K",
            detail: "Annual Inspections",
            lines: 3,
            linesM: 4,
          },
          {
            title: "Leading Single Car Delivery<br/>Service in China",
            titleM: "Leading Single Car<br/>Delivery Service in<br/>China",
            detail: "Municipalities",
            sub: "2600+",
            lines: 3,
            linesM: 4,
          },
        ],
      },
    },
  },
  head() {
    return {
      title: this.$t("title"),
      titleTemplate: "%s",
    };
  },
};
</script>

<style lang="less" scoped>
body {
  overflow-x: hidden;
}

.page4 {
  background: #f1f2f7;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(238.88deg, #ffd9cb 0%, rgba(255, 217, 203, 0) 44.73%);
  position: relative;

  @keyframes wave-animation {
    0% {
      transform: scale(1);
      opacity: 1;
    }

    100% {
      transform: scale(1.8);
      opacity: 0;
    }
  }

  .radar {
    position: absolute;
    height: 682px;
    display: flex;
    width: 100%;
    justify-content: center;
    z-index: 2;
    overflow: hidden;
    clip-path: ellipse(682px 290px);
  }

  .radar-wave {
    position: absolute;
    width: 682px;
    height: 682px;
    opacity: 1;
    border: 1.5px solid #eaeaea;
    border-radius: 100%;
    animation-fill-mode: both;
    animation: wave-animation 2s 0s linear infinite;
  }

  .radar-wave:nth-child(2) {
    animation-delay: -1s;
  }

  .radar-wave:nth-child(3) {
    animation-delay: -0.5s;
  }

  &-describe-en-version {
    font-weight: 600;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    letter-spacing: -0.02em;
    text-transform: capitalize;
    color: #353535;
    position: absolute;
  }

  &-describe {
    position: absolute;

    &-title {
      font-style: normal;
      font-weight: 600;
      font-size: 32px;
      line-height: 28px;
      color: #2b2c2e;
      text-align: center;
    }

    &-en {
      font-weight: 300;
      font-size: 20px;
      line-height: 28px;
      text-transform: capitalize;
      color: #b4b5b7;
      margin-top: 11px;
      text-align: center;
    }
  }

  &-img {
    width: 682px;
    height: 682px;
    display: block;
    overflow: hidden;

    &-active {
      transform: rotateZ(360deg);
      transition: transform;
      transition-duration: 1s;
      animation-timing-function: cubic-bezier(0.2, 0.9, 0.4, 1);
    }
  }
}

.page3 {
  background-color: white;
  position: relative;
}

.fullpage {
  width: 100%;
  height: 100vh;
  height: 100dvh;
}

.page2 {
  background: url(//img.souche.com/f2e/df526cf1d928e00860d8f84fdda64603.svg);
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;

  #page2-partical {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .fp-wrapper {
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
  }

  .content {
    align-content: center;
    display: grid;
    grid-template-columns: max-content max-content max-content;
    grid-template-rows: max-content max-content;
    row-gap: 75px;
    column-gap: 70px;
    position: relative;

    .data-from {
      position: absolute;
      color: #fff;
      font-size: 9px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      bottom: 19px;
    }
  }
}

@media screen and (max-width: 540px) {
  .fullpage {
    width: 100%;
    height: auto;
  }

  .page4 {
    padding: 55px 0;
    box-sizing: border-box;
    height: auto;
    background: linear-gradient(0deg, rgba(255, 217, 203, 0.6) 0%, rgba(255, 217, 203, 0) 100%);
    background-size: 100% 134px;
    background-position: 0 bottom;
    background-repeat: no-repeat;

    .radar {
      height: 77vw;
      display: flex;
      width: 100%;
      justify-content: center;
      z-index: 2;
      overflow: hidden;
      clip-path: ellipse(682px 290px);
    }

    .radar-wave {
      position: absolute;
      width: 77vw;
      height: 77vw;
      opacity: 1;
      border: 1.5px solid #eaeaea;
      border-radius: 100%;
      animation-fill-mode: both;
      animation: wave-animation 2s 0s linear infinite;
    }

    &-describe {
      font-size: 16px;

      &-title {
        font-size: 16px;
        line-height: 22px;
      }

      &-en {
        font-size: 10px;
        line-height: 20px;
        font-weight: 400;
        color: #353535;
        text-align: center;
        margin-top: 0px;
      }
    }

    &-describe-en-version {
      font-size: 16px;
      line-height: 20px;
    }

    &-img {
      width: 77vw;
      height: 77vw;
    }
  }

  .page3 {
    height: auto;
  }

  .page1 {
    width: 100%;
    overflow: hidden;
  }

  .page2 {
    position: relative;

    #page2-partical {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }

    .content {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: max-content max-content max-content;
      row-gap: 28px;
      padding: 45px 0 14px 0;
      box-sizing: border-box;

      .data-from {
        color: rgba(255, 255, 255, 0.9);
        font-size: 8px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        margin-top: 24px;
        opacity: 0.8;
        position: static;
        grid-column: 1 / span 2;
      }
    }
  }

  .home-en {
    .page2 {
      .content {
        column-gap: 20px;
        padding: 45px 0 14px 0;
        padding-left: 16px;
        padding-right: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/_lang/index.vue